<template>
    <div class="has-text-centered">
        <div class="field has-addons">
            <div class="control is-expanded">
                <input
                    v-model="urlInput"
                    v-validate="{ url: { require_protocol: true } }"
                    :placeholder="placeholder"
                    class="input"
                    type="text"
                    name="url"
                />
            </div>
            <!--p class="control">
        <button
          v-t="'creation.preview'"
          :disabled="errors.has('url')"
          class="button is-outlined is-link"
          @click="verifyURL"
        />
      </p-->
        </div>

        <p
            v-if="errors.has('url')"
            v-t="'creation.invalid_url'"
            class="help is-danger"
        />
        <media-card
            v-if="hasUrlInfo"
            :image="urlInfo['og:image']"
            :title="urlInfo['og:title']"
            :url="urlInfo['og:url']"
        />
    </div>
</template>

<script>
import MediaCard from '@/components/MediaCard';
import _ from 'underscore';
export default {
    name: 'InputUrl',
    components: { MediaCard },
    model: {
        prop: 'url',
    },
    props: {
        url: { type: String, default: undefined },
        placeholder: { type: String, default: undefined },
    },
    data() {
        return {
            urlInput: this.url,
            urlInfo: {},
        };
    },
    computed: {
        hasUrlInfo() {
            return !_.isEmpty(this.urlInfo);
        },
    },
    watch: {
        urlInput(newUrl) {
            this.$emit('input', newUrl);
        },
    },
    methods: {
        /* verifyURL() {
      console.log("verifyURL");
      if (!this.errors.has("url")) {
        getUrlInfo(this.urlInput)
          .then(result => {
            console.log(result.data);
            this.urlInfo = result.data;
          })
          .catch(() => {
            //this.$emit('error');
          });
      }
    }*/
    },
};
</script>

<style></style>
